var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85002 0.75C13.2336 0.75 16.95 4.37969 16.95 8.78324C16.95 13.2569 13.173 16.3963 9.68432 18.5311C9.43007 18.6746 9.14252 18.75 8.85002 18.75C8.55752 18.75 8.26997 18.6746 8.01572 18.5311C4.53352 16.3755 0.75 13.2724 0.75 8.78324C0.75 4.37969 4.4665 0.75 8.85002 0.75Z",
    fill: "#FF4444",
    stroke: "#FF4444",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 8.85008C12.0001 10.5898 10.5898 12.0001 8.85008 12.0001C7.11038 12.0001 5.70007 10.5898 5.70007 8.85008C5.70007 7.11038 7.11038 5.70007 8.85008 5.70007C10.5898 5.70007 12.0001 7.11038 12.0001 8.85008Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcs);
export default __webpack_public_path__ + "static/media/location_ics.331fa565201bea9e7b78026a0d0a541a.svg";
export { ForwardRef as ReactComponent };